function ConditionPin(props) {
    // adjust the size of the arrow based on the length of the character input
    const len = props.max_length_pinname;

    let width_outer = (len+10) + 20 + 8;
    let width_input = (len+10);
    let arr_endpoint = width_outer-8;
    width_outer = width_outer.toString()+'px';
    width_input = width_input.toString()+'px';
    arr_endpoint = arr_endpoint.toString();
    let arr_coord="M 16 10 " + arr_endpoint + " 10";


    return(
        <>
        <div style={{position:'relative', magin:'0px', padding:'0px', width:width_outer, height:'35px'}}>
                <input id={'condition_pin_'+props.id} placeholder='Response' value={props.name} onChange={props.handleEnter} autoComplete='off' style={{position:'relative', fontFamily:'Roboto', fontSize:'14px', width: width_input, left:'20px', top: "0px", marginLeft: "0px", borderLeft: "2px solid var(--aixelo-blue)" , marginTop:"0px", marginBottom:"0px", paddingLeft: "3px"}} />
                <div style={{position:'relative', display: 'flex', left:'0px', top:'0px', width:width_outer, height:'20px'}}>
                    <svg style={{position:'relative', left:'0px', top:'-6px', width: '100%', height:'20px'}}>
                        <defs>
                        <marker
                        id="triangleCondition"
                        viewBox="0 0 10 10"
                        refX="1"
                        refY="5"
                        markerUnits="strokeWidth"
                        markerWidth="6"
                        markerHeight="6"
                        orient="auto">
                        <path d="M 0 0 L 10 5 L 0 10 z" fill="var(--aixelo-blue)" />
                        </marker>
                    </defs>
                    <circle cx="11px" cy="10px" r="5px" fill="var(--aixelo-blue-light)" stroke="var(--aixelo-blue)" />
                    <path   d={arr_coord} fill="var(--aixelo-blue)" stroke="var(--aixelo-blue)" strokeWidth="1.5" markerEnd="url(#triangleCondition)"/>
                    </svg>
                </div>
        </div>
        </>
    );
}
export default ConditionPin;